import Vue from "vue";
import Vuetify from "vuetify/lib";
import theme from "../theme";
import "vuetify/dist/vuetify.min.css"; // Ensure you are using css-loader

Vue.use(Vuetify, {
  iconfont: "md",
  theme,
});
